import { defineComponent as a, computed as o, openBlock as i, createElementBlock as c, createElementVNode as e, toDisplayString as d, createCommentVNode as f, normalizeStyle as _ } from "vue";
const h = ["viewBox"], u = /* @__PURE__ */ e("mask", { id: "70da2250-6bf6-4622-9725-10c606ef253f" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#70da2250-6bf6-4622-9725-10c606ef253f)" }, p = { key: 0 }, k = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "m0 256 259-45.3L512 256v256H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M0 0h512v256H0z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M55.7 256a122.4 122.4 0 1 0 244.8 0l-123-24z"
}, null, -1), x = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M55.7 256a122.4 122.4 0 1 1 244.8 0z"
}, null, -1), w = { fill: "none" }, y = ["r"], N = /* @__PURE__ */ a({
  __name: "gl",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(n) {
    const t = n, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), r = o(() => 256 + t.strokeWidth / 2);
    return (z, W) => (i(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      u,
      e("g", m, [
        t.flagName ? (i(), c("title", p, d(t.flagName), 1)) : f("", !0),
        k,
        g,
        v,
        x
      ]),
      e("g", w, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: _({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, y)
      ])
    ], 8, h));
  }
});
export {
  N as default
};
//# sourceMappingURL=gl-f9d1ce5e.js.map
